import { createRouter, createWebHistory } from 'vue-router';
import Home from '../components/Home.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'MK Plus - Global Quality Auditor & Consultancy Services',
      description:
        'Expert consultancy in software quality audit, data warehouse ETL testing, mobile app test automation with Appium, and iOS/Android app development.',
      keywords: 'quality audit, data quality, test automation, mobile app development, Appium, iOS, Android',
      type: 'website',
      url: 'https://mk.plus',
    },
  },
  {
    path: '/about',
    name: 'About',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      title: 'About Maksym Krutskykh - MK Plus Consultancy',
      description:
        'Learn about Maksym Krutskykh, a global software quality auditor with expertise in quality assurance, data warehouse testing, and mobile app development.',
      keywords: 'Maksym Krutskykh, quality auditor, software consultant, profile',
      type: 'profile',
      url: 'https://mk.plus/about',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

/**
 * Router hook to update SEO on page change
 */
router.afterEach((to) => {
  // Update SEO meta tags based on route
  if (to.meta && to.meta.title) {
    Vue.prototype.$seo.setPageMeta({
      title: to.meta.title,
      description: to.meta.description,
      keywords: to.meta.keywords,
      type: to.meta.type || 'website',
      url: to.meta.url || 'https://mk.plus' + to.path,
    });

    // Track page view
    Vue.prototype.$seo.trackPageView(to.name || 'Page');
  }
});

export default router;

